import { useState } from "react";
import type { MappedVerifiedMember } from "./mapVerifiedMember";
import { MemberDashboard } from "./components/MemberDashboard";
import { OTPVerification } from "./components/OTPVerification";

const PAGE_BG =
  "linear-gradient(165deg, #f8fafc 0%, #fffbeb 28%, #f0f9ff 55%, #f8fafc 100%)";

/**
 * Public Member Details portal — OTP gate + loyalty dashboard.
 * Import and mount on a public route (e.g. `/member-details`).
 */
export default function MemberDetailsPage() {
  const [verifiedMember, setVerifiedMember] =
    useState<MappedVerifiedMember | null>(null);

  return (
    <div
      className="h-screen min-h-0 overflow-x-hidden overflow-y-auto"
      style={{ background: PAGE_BG }}
    >
      <div className="relative min-h-full">
        <div
          className="pointer-events-none absolute inset-0 opacity-[0.35]"
          style={{
            backgroundImage:
              "radial-gradient(circle at 1px 1px, rgba(148,163,184,0.35) 1px, transparent 0)",
            backgroundSize: "24px 24px",
          }}
        />

        <header className="relative z-10 border-b border-slate-200/60 bg-white/70 backdrop-blur-md">
          <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-4 sm:px-6 lg:px-8">
            <div className="flex items-center gap-2.5">
              <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-gradient-to-br from-amber-400 to-amber-600 text-sm font-bold text-white shadow-md shadow-amber-500/25">
                L
              </div>
              <div>
                <p className="text-sm font-semibold tracking-tight text-slate-900">
                  Loyyal Member Portal
                </p>
                <p className="text-[11px] text-slate-500">
                  Loyalty · Rewards · Perks
                </p>
              </div>
            </div>
            {verifiedMember ? (
              <button
                type="button"
                onClick={() => setVerifiedMember(null)}
                className="rounded-lg px-3 py-1.5 text-xs font-medium text-slate-500 transition hover:bg-slate-100 hover:text-slate-800"
              >
                Sign out
              </button>
            ) : null}
          </div>
        </header>

        <main className="relative z-10">
          {verifiedMember ? (
            <MemberDashboard
              initialProfile={verifiedMember.profile}
              initialStats={verifiedMember.stats}
            />
          ) : (
            <OTPVerification
              onVerified={(mapped) => setVerifiedMember(mapped)}
            />
          )}
        </main>

        <footer className="relative z-10 border-t border-slate-200/60 bg-white/50 py-6 text-center text-xs text-slate-400 backdrop-blur-sm">
          © {new Date().getFullYear()} Loyyal · Member Details Portal
        </footer>
      </div>
    </div>
  );
}
